import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormAgente from "./formulario";

export function AgenteIncluir() {
  const idagente = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Incluir Agente" />
        <FormAgente idagente={idagente.id} acao="Novo" />
      </div>
    </>
  );
} 